// extracted by css-extract-rspack-plugin
export default {"cls1":"News-cls1_nLO","cls2":"News-cls2_38C News-cls1_nLO"};